import { defineMessages } from "react-intl";

export const categoryLimitsMessages = defineMessages({
  sectionTitle: {
    id: "extrasCategories.accommodationLimits.title",
    defaultMessage: "Limits per category",
  },
  accommodationFallback: {
    id: "extrasCategories.accommodationLimits.accommodationFallback",
    defaultMessage: "accommodation",
  },
  toggle: {
    id: "extrasCategories.accommodationLimits.toggle",
    defaultMessage: "Limit {category} in this accommodation",
  },
  included: {
    id: "extrasCategories.accommodationLimits.included.label",
    defaultMessage: "Included in the price",
  },
  includedHelp: {
    id: "extrasCategories.accommodationLimits.included.help",
    defaultMessage:
      "Per unit of {accommodation}. If the guest books two, it applies to each one. Included units are consumed following the order of your extras.",
  },
  max: {
    id: "extrasCategories.accommodationLimits.max.label",
    defaultMessage: "Maximum allowed",
  },
  maxHelp: {
    id: "extrasCategories.accommodationLimits.max.help",
    defaultMessage:
      "Per unit of {accommodation}, in any combination of the extras of this category. If the guest books two, it applies to each one.",
  },
  placeholder: {
    id: "extrasCategories.accommodationLimits.placeholder",
    defaultMessage: "Select…",
  },
  extrasTitle: {
    id: "extrasCategories.accommodationLimits.extras.title",
    defaultMessage: "Extras of {category} sold in this accommodation",
  },
  columnExtra: {
    id: "extrasCategories.accommodationLimits.extras.column.extra",
    defaultMessage: "Extra",
  },
  columnType: {
    id: "extrasCategories.accommodationLimits.extras.column.type",
    defaultMessage: "Type",
  },
  columnPrice: {
    id: "extrasCategories.accommodationLimits.extras.column.price",
    defaultMessage: "Price",
  },
  inactive: {
    id: "extrasCategories.accommodationLimits.extras.inactive",
    defaultMessage: "Inactive",
  },
  firstFree: {
    id: "extrasCategories.accommodationLimits.firstFree",
    defaultMessage:
      "With the current order of your extras, the first {category} free of charge would be {extra}. The order is changed in Inventory > Extras and services.",
  },
});
